export const INNOCENT = 'innocent';
export const AVAILABLE = 'available';
export const PROCESSING = 'processing';
export const FAILED = 'failed';
